import { useState } from "react";
import { Building2, CheckCircle2 } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useCachedGet } from "@/lib/cache";
import { imageUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Chip, ChipRow } from "@/components/post/FormBits";
import { BusinessGate, KIND_LABEL } from "@/components/business/BusinessGate";

const STATUS = { approved: ["معتمدة", "Approved", "bg-emerald-50 text-emerald-700"], pending: ["قيد المراجعة", "Under review", "bg-amber-50 text-amber-700"],
  rejected: ["مرفوضة", "Rejected", "bg-red-50 text-red-700"], expired: ["منتهية الرخصة", "Licence expired", "bg-red-50 text-red-700"] };

export default function MyBusiness() {
  const { lang } = useLang();
  const L = (ar, en) => (lang === "ar" ? ar : en);
  const { data, reload } = useCachedGet("/business/me");
  const [kind, setKind] = useState("");
  const list = data || [];
  const current = list.find((b) => b.kind === kind);
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F8F6]">
      <Navbar />
      <main className="max-w-[1100px] mx-auto px-5 sm:px-8 w-full py-10 flex-1" data-testid="my-business-page">
        <h1 className="font-headline text-2xl sm:text-3xl font-bold mb-2">{L("تسجيل الجهة / الشركة", "Business registration")}</h1>
        <p className="text-slate-600 mb-8">{L("أقسام العمالة المساعدة والخدمات المنزلية متاحة فقط للجهات المرخصة والمعتمدة من إدارة بازارو.", "Domestic workers and home services are reserved for licensed businesses approved by Bazaroo.")}</p>
        {list.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-4 mb-10" data-testid="my-business-list">
            {list.map((b) => {
              const st = STATUS[b.status] || STATUS.pending;
              return (
                <button key={b.business_id} onClick={() => setKind(b.kind)} className={`text-start bg-white rounded-3xl border p-5 flex items-center gap-4 hover:border-[#064E3B] ${kind === b.kind ? "border-[#064E3B]" : "border-[#E5E5E0]"}`} data-testid={`my-business-${b.kind}`}>
                  {b.logo ? <img src={imageUrl(b.logo)} alt="" className="w-14 h-14 rounded-2xl object-cover" /> : <span className="w-14 h-14 rounded-2xl bg-[#E6EFEB] flex items-center justify-center"><Building2 className="w-6 h-6 text-[#064E3B]" /></span>}
                  <span className="flex-1 min-w-0">
                    <span className="block font-bold truncate">{(lang === "en" && b.name_en) || b.name_ar || b.name}</span>
                    <span className="block text-sm text-slate-500">{L(...(KIND_LABEL[b.kind] || [b.kind, b.kind]))}</span>
                  </span>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${st[2]}`} data-testid={`my-business-status-${b.kind}`}>{L(st[0], st[1])}</span>
                </button>
              );
            })}
          </div>
        )}
        <h2 className="font-bold text-base mb-3">{L("اختر نوع الجهة", "Choose business type")}</h2>
        <ChipRow>{Object.entries(KIND_LABEL).map(([id, [ar, en]]) => <Chip key={id} testid={`biz-kind-${id}`} active={kind === id} onClick={() => setKind(id)} label={L(ar, en)} />)}</ChipRow>
        <div className="mt-8">
          {kind && current?.status === "approved" && <p className="rounded-2xl bg-[#E6EFEB] p-5 font-bold flex items-center gap-2" data-testid="my-business-approved"><CheckCircle2 className="w-5 h-5 text-[#2D6A4F]" /> {L("مركز معتمد ✓ — يمكنك نشر إعلاناتك", "Approved centre ✓ — you can post your ads")}</p>}
          {kind && <BusinessGate key={kind} kind={kind} business={current} lang={lang} onChanged={reload} />}
        </div>
      </main>
      <Footer />
    </div>
  );
}
